<div id="{{ type }}" class="info-accordion" *ngIf="room">

    <h6 class="pt-3 pb-4 mb-0" *ngIf="type === 'advantages'">
      <span class="title_2">{{ 'PROCESSES.ACCOMMODATION.ROOM.ADVANTAGES' | translate }}</span>
    </h6>

  <h2 class="pt-3 pb-4 mb-0" *ngIf="type === 'features'">
    <span class="title_2">{{ 'PROCESSES.ACCOMMODATION.LIST.AMENITIES_CHARAC' | translate }}</span>
  </h2>

<!--  AMENITIES  -->
    <div class="d-flex flex-row flex-wrap font-14" *ngIf="type === 'features'">
      <div class="w-100 subtitle_1 txt-darkGray pb-2" *ngIf="(amenities_1 && amenities_1.length > 0 && room.partner_type == 'room')">
        {{ "PROCESSES.ACCOMMODATION.AMENITIES.TITLE_1_BIS" | translate }}
      </div>

      <div class="w-100 h-100 d-flex align-items-center justify-content-center mb-5" *ngIf="isLoading">
        <div class="spinner-border text-primary"></div>
      </div>

      <app-accom-roomspec class="w-100" [room]="room" [hideIfMobile]="false" [numberDisplay]="5" [isModal]="false" [isCarac]="true"></app-accom-roomspec>

    </div>

<!--  ROOM ADVANTAGES  -->
    <div class="d-flex flex-column" *ngIf="type === 'advantages'">
      <div class="d-flex flex-row align-items-center w-100">
        <lf-icon name="livinGarant" width="18px" height="18px" fillColor="#00C49A"></lf-icon>
        <div class="font-14 icon-margin">
          <div class="font-trueno-bold">{{ 'ROOM.ADVANTAGES.GUARANTOR_TITLE' | translate }}</div>
            <p class="lf-font">{{ 'ROOM.ADVANTAGES.GUARANTOR' | translate }}</p>
        </div>
      </div>

      <div class="d-flex flex-row align-items-center gap-8 w-100">
        <lf-icon name="livinProtect" width="18px" height="18px" fillColor="#00C49A"></lf-icon>
        <div class="font-14 icon-margin">
          <div class="font-trueno-bold">{{ 'ROOM.ADVANTAGES.ROOM_VERIFIED_TITLE' | translate }}</div>
          <p class="lf-font">{{ 'ROOM.ADVANTAGES.ROOM_VERIFIED' | translate }}</p>
        </div>
      </div>

      <div class="d-flex flex-row gap-8 align-items-center">
        <lf-icon name="returnMoney" width="18px" height="18px" fillColor="#00C49A"></lf-icon>
        <p class="lf-font icon-margin">{{ 'ROOM.ADVANTAGES.REFUND' | translate }}</p>
      </div>
    </div>
</div>

<span class="show-more" (click)="openModal(amenitiesModal)" *ngIf="type === 'features'">{{'COMMON.SHOW.MORE' | translate }}</span>

<ng-template #amenitiesModal let-modal>
  <div class="container py-3 px-5">
    <div class="col-12 row position-relative align-items-center">
      <div class="d-flex flex-row align-items-center mt-3 border-bottom border-2 pb-3" [ngClass]="isMobile ? 'flex-wrap': 'gap-16' ">
        <div [ngClass]="{'w-100 d-flex mt-2': isMobile}">
          <h6 class="pt-3 w-50 subtitle_1" [ngClass]="{'carac-title': !isMobile}">
            <span class="title_2" *ngIf="type === 'features'">{{ 'PROCESSES.ACCOMMODATION.LIST.CHARAC' | translate }}</span> ({{ "PROCESSES.ACCOMMODATION.FILTER." + room['partner_type'].toUpperCase() | translate }})
          </h6>
        </div>
        <app-accom-roomspec class="flex-grow-1" [room]="room" [hideIfMobile]="false" [numberDisplay]="4" [isModal]="true" [isCarac]="true"></app-accom-roomspec>
      </div>

      <div class="row font-14 pt-3" *ngIf="type === 'features'">
          <div class="col-lg-6 col-md-6 col-sm-12 pt-4" [ngClass]="{'border-end' : !isMobile, 'border-2' : !isMobile}">
            <h6 class="subtitle_1 pe-3">
              {{ "PROCESSES.ACCOMMODATION.AMENITIES.TITLE_2_BIS" | translate }}
            </h6>
            <div class="row pt-4 pe-4 pb-4">
              <div class="col-lg-4 col-md-4 col-sm-12 d-flex mt-2 mb-2 text_3" *ngFor="let amenity of amenities_2">
                <lf-icon class="icon-check icon-carac" name="{{amenity.symbol.toLowerCase()}}" width="18px" height="18px" fillColor="#1C69FF"></lf-icon>
                {{ "PROCESSES.ACCOMMODATION.AMENITIES." + (amenity.title ? amenity.title.toUpperCase() : amenity.description.toUpperCase()) | translate }}
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 pt-4" [ngClass]="{'ps-4': !isMobile}">
            <h3 class="subtitle_1" [ngClass]="{'ps-3': !isMobile}">
              {{ "PROCESSES.ACCOMMODATION.AMENITIES.TITLE_1_BIS" | translate }}
            </h3>
            <div class="row pt-4 pb-4" [ngClass]="{'ps-4': !isMobile}">
              <div class="col-lg-4 col-md-4 col-sm-12 d-flex mt-2 mb-2 text_3" *ngFor="let amenity of amenities_1">
                <lf-icon class="icon-check icon-carac" name="{{amenity.symbol.toLowerCase()}}" width="18px" height="18px" fillColor="#1C69FF"></lf-icon>
                <span> {{ "PROCESSES.ACCOMMODATION.AMENITIES." + (amenity.title ? amenity.title.toUpperCase() : amenity.description.toUpperCase()) | translate }}</span>
              </div>
              <ng-container *ngIf="basisNotIncluded && basisNotIncluded.length>0">
                <div class="col-lg-4 col-md-4 col-sm-12 d-flex mt-2 mb-2" *ngFor="let notIncluded of basisNotIncluded">
                  <lf-icon class="icon-check icon-carac" [name]="notIncluded.icon" width="18px" height="18px" fillColor="#525458"></lf-icon>
                  <span class="text-decoration-line-through">{{ ("PROCESSES.ACCOMMODATION.AMENITIES." + notIncluded.name)| translate }}</span>
                </div>
              </ng-container>
            </div>
        </div>
      </div>
    </div>
    <button class="btn position-absolute close_btn border-0" (click)="modal.dismiss()">
      <span class="material-icons-outlined btn-close-black">close</span>
    </button>
  </div>
</ng-template>

<ng-template #chargesModal let-modal>
  <div class="container py-3 px-3">
    <div class="col-12 row position-relative align-items-center">
      <h6 class="pt-3 pb-3">
        <div class="d-flex flex-row font-trueno-bold align-items-center"  *ngIf="type === 'charges'">
          {{ 'PROCESSES.ACCOMMODATION.LIST.RENTAL_CHARGES' | translate }} ({{ 'PROCESSES.ACCOMMODATION.CHARGES.PROVISIONS_ON_COSTS' | translate }})
          <span class="material-icons txt-blue-sky font-18 d-flex align-items-center justify-content-center ms-1" (click)="$event.stopPropagation();gotoHelpCenter()">contact_support</span>
        </div>
      </h6>

      <app-accom-roomspec class="flex-grow-1" [room]="room" [hideIfMobile]="false" [numberDisplay]="4"></app-accom-roomspec>


      <div class="d-flex flex-wrap flex-row" *ngIf="type === 'charges'">
        <div class="d-flex flex-row align-items-center gap-16 w-50" *ngIf="room.property_price.wifi">
          <span class="material-icons-outlined txt-grad-blue font-20">wifi</span>
          <div class="font-14">
            <div class="mediumGray">{{ "PROCESSES.ACCOMMODATION.AMENITIES.WIFI" | translate }}</div>
            <div class="txt-blue-sky">
              {{ ("PROCESSES.ACCOMMODATION.LIST." + (room.property_price.wifi || (room.charges && room.charges.includes('wifi')) ? 'INCLUDED' : 'NOT_INCLUDED') ) | translate }}
            </div>
          </div>
        </div>

        <div class="d-flex flex-row align-items-center gap-8 w-50" *ngIf="room.property_price.electricity">
          <span class="material-icons-outlined txt-grad-blue font-20">flash_on</span>
          <div class="font-14">
            <div class="mediumGray">{{ "PROCESSES.ACCOMMODATION.CHARGES.ELECTRICITY" | translate }}</div>
            <div class="txt-blue-sky">
              {{ ("PROCESSES.ACCOMMODATION.LIST." + (room.property_price.electricity || (room.charges && room.charges.includes('électricité')) ? 'INCLUDED' : 'NOT_INCLUDED') ) | translate }}
            </div>
          </div>
        </div>

        <div class="d-flex flex-row align-items-center gap-8 w-50">
          <span class="material-icons-outlined txt-grad-blue font-20">security</span>
          <div class="font-14">
            <div class="mediumGray">
              {{ "PROCESSES.HOUSING_INSURANCE.TITLE" | translate }}
              <span class="material-icons font-14 pointer v-middle" (click)="goToInsuranceHelpCenter()">contact_support</span>
            </div>
            <div class="txt-blue-sky">
              {{ ("PROCESSES.ACCOMMODATION.LIST." + (room.property_price.insurance || (room.charges && room.charges.includes('assurance habitation')) ? 'INCLUDED' : 'NOT_INCLUDED') ) | translate }}
            </div>
          </div>
        </div>

        <div class="d-flex flex-row align-items-center gap-8 w-50" *ngIf="room.property_price.water">
          <span class="material-icons-outlined txt-grad-blue font-20">opacity</span>
          <div class="font-14">
            <div class="mediumGray">{{ "PROCESSES.ACCOMMODATION.CHARGES.WATER" | translate }}</div>
            <div class="txt-blue-sky">
              {{ ("PROCESSES.ACCOMMODATION.LIST." + (room.property_price.water || (room.charges && room.charges.includes('eau')) ? 'INCLUDED' : 'NOT_INCLUDED') ) | translate }}
            </div>
          </div>
        </div>

        <div class="d-flex flex-row align-items-center gap-8 w-50" *ngIf="room.property_price.cleaning">
          <span class="material-icons-outlined txt-grad-blue font-20">cleaning_services</span>
          <div class="font-14">
            <div class="mediumGray">{{ "PROCESSES.ACCOMMODATION.CHARGES.CLEANING" | translate }}</div>
            <div class="txt-blue-sky">
              {{ ("PROCESSES.ACCOMMODATION.LIST." + (room.property_price.cleaning || (room.charges && room.charges.includes('ménage')) ? 'INCLUDED' : 'NOT_INCLUDED') ) | translate }}
            </div>
          </div>
        </div>

        <div class="d-flex flex-row align-items-center gap-8 w-50" *ngIf="room.property_price.gaz">
          <span class="material-icons txt-grad-blue font-20">whatshot</span>
          <div class="font-14">
            <div class="mediumGray">{{ "PROCESSES.ACCOMMODATION.CHARGES.GAZ" | translate }}</div>
            <div class="txt-blue-sky">
              {{ ("PROCESSES.ACCOMMODATION.LIST." + (room.property_price.gaz || (room.charges && room.charges.includes('gaz')) ? 'INCLUDED' : 'NOT_INCLUDED') ) | translate }}
            </div>
          </div>
        </div>
      </div>

    </div>
    <button class="btn position-absolute close_btn border-0" (click)="modal.dismiss()">
      <span class="material-icons-outlined text-black">close</span>
    </button>
  </div>
</ng-template>


